import { ClearFix } from './ClearFix';
export var StyledClearFix = ClearFix;